import { DeliveryStoreSelectorModal } from 'features/store/pages/delivery-store-selector';

export default function DeliveryStoreSelectorModalPage() {
  return <DeliveryStoreSelectorModal />;
}
